export enum CustomerFlow {
  Base = 'base',
  FlightOnlyFromMarketplace = 'flightOnlyFromMarketplace',
  InfiniteLoadReload = 'infiniteLoadReload',
}
